import React from "react";
import { SarsModel } from "../../domain/SarsModel";
import { AttachEmailDialog } from "./dialogs/AttachEmailDialog";
import { DialogType, EntityDialog } from "./types";

type RenderDialogProps = {
  focusedEntity: EntityDialog | null;
  onClose: () => void;
  sarItem: SarsModel;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focusedEntity,
  onClose,
  sarItem
}) => {
  if (!focusedEntity) return null;

  const { dialogType } = focusedEntity;
  switch (dialogType) {
    case DialogType.AttachEmail:
      return <AttachEmailDialog onClose={onClose} resource={sarItem} />
    default:
      return null;
  }
}